'use strict';

import $ from 'jquery';
import objectFitImages from 'object-fit-images';

$(document).ready(function(){
  var imageElementSelectors = [
    '.field--name-field-media-image img',
    '.cta-image img',
    '.cta-tile__image img'
  ];

  for (var key in imageElementSelectors) {
    var element = document.querySelectorAll(imageElementSelectors[key]);
    if (element.length > 0) {
      objectFitImages(imageElementSelectors[key]);      
    }
  }
})
